import React from 'react';
import configData from '../../config.json';
import MarketingELearningCard from './MarketingELearningCard';
import MarketingELearningShell from './MarketingELearningShell';
import { demoBreakthroughModules } from './marketingDemoData';
import './MarketingAssets.css';

const completeLength = demoBreakthroughModules.filter((m) => m.isCompleted)
    .length;

/** Static V1 E-Learning board — Breakthrough tab for marketing. */
const MarketingELearningBoardPreview = () => (
    <MarketingELearningShell activeTab={1}>
        <div className="MyBreakThroughModules__container">
            <section className="paragraph-3 ModuleDescription">
                <p className="TitleContentElearning">
                    My Breakthrough Experience: {completeLength}/
                    {demoBreakthroughModules.length}
                </p>
                <span>PHASE 2:</span> A new module unlocks every 7 days for
                12-weeks
            </section>
            <div className="eLearningBoard__modules OolaScroll">
                {demoBreakthroughModules.map((item, i) => (
                    <MarketingELearningCard
                        key={item.id}
                        item={item}
                        showLeftBorder={i % 2 === 1}
                    />
                ))}
            </div>
        </div>
    </MarketingELearningShell>
);

export default MarketingELearningBoardPreview;
